import { render, staticRenderFns } from "./research_graph_block.vue?vue&type=template&id=400a119e&"
import script from "./research_graph_block.vue?vue&type=script&lang=js&"
export * from "./research_graph_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports